
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.use(VueLazyload,{
  error:'./assets/img/banner2.jpg'
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // mounted() {
  //   this.$router.beforeEach((to,from,next)=>{
  //     window.scrollTo(0,0);
  //     next();
  //   })
  // }
})




// WEBPACK FOOTER //
// ./src/main.js